// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__2am3D","headerCell":"styles_headerCell__XDWnj"};